// extracted by mini-css-extract-plugin
export var hero_bg = "styles-module--hero_bg--C2_B3";